<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            分月收费项目
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledDel" @click="handleDel">删除</el-button>
                </el-row>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="名称"></el-table-column>

                        <el-table-column prop="price" label="价格(元/月)"></el-table-column>

                        <el-table-column prop="months" label="收费月份"></el-table-column>

                        <el-table-column prop="createTime" :formatter="formatterTime" label="创建时间"></el-table-column>

                      
                    </el-table>
                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:ItemList="ItemList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:ItemList="ItemList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                disabledDel:true,
                row:null,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                th:0,
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                if(this.menuButtonList.indexOf("删除")!=-1){
                    this.disabledDel =false;
                }
                
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            //删除
            handleDel(){
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.loading = true;
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl+"CheckinUnfixedMoney/Delete",
                            data: {
                                timeStr:timeStr,
                                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                                staffCode: getStaffCode(),
                                checkinUnfixedMoneyCode:this.row.checkinUnfixedMoneyCode
                            }
                        }).then( (response)=> {
                            if(response.data.error == 0){
                                this.getList();
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            }else if(response.data.error == 1){
                                    this.$message({type: 'info', message: response.data.message});
                                }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinUnfixedMoney/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit = true;
                    this.disabledDel = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
